<script setup lang="ts">
const route = useRoute();

const isHotel = computed(() => route.path === '/hotel');
</script>

<template>
    <div class="ticket-wrapper">
        <div class="ticket-limiter container">
            <mr-typography
                v-show="!isHotel"
                type="h2"
                weight="600"
                size="x-large"
                color="var(--cool-gray-800)"
                class="title"
            >
                مسیرهای پرتردد
            </mr-typography>
            <div class="tickets-container">
                <div class="buy-ticket">
                    <div class="ticket-box">
                        <p class="ticket-title">مِستربلیط</p>
                        <a class="ticket-link" href="/plane-ticket">
                            خرید بلیط هواپیما
                        </a>
                        <a class="ticket-link" href="/train-ticket">
                            خرید بلیط قطار
                        </a>
                        <a class="ticket-link" href="/bus-ticket">
                            خرید بلیط اتوبوس
                        </a>
                        <a
                            class="ticket-link"
                            href="/support/terms-and-conditions"
                        >
                            شرایط و مقررات
                        </a>
                        <a class="ticket-link" href="https://mrbilit.com/mag/">
                            وبلاگ مِستربلیط
                        </a>
                    </div>
                    <div class="ticket-box">
                        <p class="ticket-title">هواپیما داخلی</p>
                        <a class="ticket-link" href="/flights/THR-MHD">
                            بلیط هواپیما تهران مشهد
                        </a>
                        <a class="ticket-link" href="/flights/THR-KIH">
                            بلیط هواپیما تهران کیش
                        </a>
                        <a class="ticket-link" href="/flights/THR-IFN">
                            بلیط هواپیما تهران اصفهان
                        </a>
                        <a class="ticket-link" href="/flights/THR-SYZ">
                            بلیط هواپیما تهران شیراز
                        </a>
                        <a class="ticket-link" href="/flights/THR-AWZ">
                            بلیط هواپیما تهران اهواز
                        </a>
                    </div>
                    <div class="ticket-box">
                        <p class="ticket-title">قطار</p>
                        <a class="ticket-link" href="/trains/tehran-mashhad">
                            بلیط قطار تهران مشهد
                        </a>
                        <a
                            class="ticket-link"
                            href="/trains/tehran-bandar_abbas"
                        >
                            بلیط قطار تهران بندرعباس
                        </a>
                        <a class="ticket-link" href="/trains/tehran-tabriz">
                            بلیط قطار تهران تبریز
                        </a>
                        <a class="ticket-link" href="/trains/tehran-shiraz">
                            بلیط قطار تهران شیراز
                        </a>
                        <a class="ticket-link" href="/trains/tehran-ahvaz">
                            بلیط قطار تهران اهواز
                        </a>
                    </div>
                    <div class="ticket-box">
                        <p class="ticket-title">اتوبوس</p>
                        <a class="ticket-link" href="/buses/tehran-esfahan">
                            بلیط اتوبوس تهران اصفهان
                        </a>
                        <a class="ticket-link" href="/buses/tehran-mashhad">
                            بلیط اتوبوس تهران مشهد
                        </a>
                        <a class="ticket-link" href="/buses/tehran-shiraz">
                            بلیط اتوبوس تهران شیراز
                        </a>
                        <a class="ticket-link" href="/buses/tehran-tabriz">
                            بلیط اتوبوس تهران تبریز
                        </a>
                        <a class="ticket-link" href="/buses/tehran-ahwaz">
                            بلیط اتوبوس تهران اهواز
                        </a>
                    </div>
                    <div class="ticket-box">
                        <p class="ticket-title">هواپیما خارجی</p>
                        <a class="ticket-link" href="/international-flights">
                            بلیط هواپیما خارجی
                        </a>
                        <a class="ticket-link" href="/flights/DXB">
                            بلیط هواپیما دبی
                        </a>
                        <a class="ticket-link" href="/flights/IST">
                            بلیط هواپیما استانبول
                        </a>
                        <a class="ticket-link" href="/flights/AYT">
                            بلیط هواپیما آنتالیا
                        </a>
                        <a class="ticket-link" href="/flights/BGW">
                            بلیط هواپیما بغداد
                        </a>
                    </div>
                    <div class="ticket-box">
                        <p class="ticket-title">سایر خدمات</p>
                        <a class="ticket-link" href="/taxi">
                            تاکسی دربستی و بین شهری
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.ticket-wrapper {
    background-color: usePalette($p-cool-gray, $p-100);
    padding: 45px 16px 40px 16px;
}

.ticket-limiter {
    display: flex;
    flex-direction: column;
    gap: 16px;
    .title {
        margin-inline: auto;
    }
}
.tickets-container {
    display: flex;
    flex-direction: row;
    justify-content: center;
    @include mobile-only {
        padding: 0 8px 40px;
    }
}
.buy-ticket {
    display: inline-flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
    width: 100%;
    @include mobile-only {
        width: 100%;
        flex-direction: column;
    }
}

.ticket-box {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    text-align: right;
    padding: 0 8px;
    @include mobile-only {
        border-right: none;
        width: 100%;
        padding: 0 0 27px 0;
        justify-content: center;
        :last-child {
            padding: 0 0 48px 0;
            border-bottom: none;
        }
    }
}
.ticket-title {
    @include tg-l($w7);
    color: usePalette($p-cool-gray, $p-800);
    margin: 0 0 16px 0;
    @include mobile-only {
        margin: 0 0 8px 0;
        text-align: center;
    }
}
.ticket-link {
    @include tg-s();
    text-align: right;
    color: usePalette($p-gray, $p-600);
    margin-bottom: 8px;
    @include mobile-only {
        margin-bottom: 2px;
        font-size: 10px;
        text-align: center;
    }
}
</style>
